// Import React specific files
import React from 'react';
import { render } from 'react-dom';

// Import Root
import Root from './Root';

// Import scss
// Font Awesome scss
import "font-awesome/scss/font-awesome.scss";
// Slick carousel
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
// App scss
import './sass/app.scss';

// Render application
render(<Root />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js